
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ClassMetadata, IGetTransactionCriteria, ISaveTransactionCriteria, ITransaction, ITransactionGroup } from "@tylertech/tyler-api-types";

/**
 * TransactionService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class TransactionService {
    constructor(private readonly $apiService: ApiService) { }
    
    DeleteOrder(pTransaction: ITransactionGroup): Promise<boolean> {
        return this.$apiService.sendAuth("ITransactionService/DeleteOrder", pTransaction);
    }
    DeleteRequest(pTransaction: ITransactionGroup): Promise<boolean> {
        return this.$apiService.sendAuth("ITransactionService/DeleteRequest", pTransaction);
    }
    GetAdjustmentTransaction(pId: string): Promise<ITransaction> {
        return this.$apiService.sendAuth("ITransactionService/GetAdjustmentTransaction", pId);
    }
    GetNextOrderNumber(): Promise<string> {
        return this.$apiService.sendAuth("ITransactionService/GetNextOrderNumber");
    }
    GetNextRequestNumber(): Promise<string> {
        return this.$apiService.sendAuth("ITransactionService/GetNextRequestNumber");
    }
    GetOrder(pId: string): Promise<ITransactionGroup> {
        return this.$apiService.sendAuth("ITransactionService/GetOrder", pId);
    }
    GetRequest(pId: string): Promise<ITransactionGroup> {
        return this.$apiService.sendAuth("ITransactionService/GetRequest", pId);
    }
    GetTransactionMetadata(): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("ITransactionService/GetTransactionMetadata");
    }
    GetTransactions(pCriteria: IGetTransactionCriteria): Promise<ITransaction[]> {
        return this.$apiService.sendAuth("ITransactionService/GetTransactions", pCriteria);
    }
    SaveOrder(pCriteria: ISaveTransactionCriteria): Promise<ITransactionGroup> {
        return this.$apiService.sendAuth("ITransactionService/SaveOrder", pCriteria);
    }
    SaveRequest(pCriteria: ISaveTransactionCriteria): Promise<ITransactionGroup> {
        return this.$apiService.sendAuth("ITransactionService/SaveRequest", pCriteria);
    }
    VoidOrder(pId: string): Promise<ITransactionGroup> {
        return this.$apiService.sendAuth("ITransactionService/VoidOrder", pId);
    }
}
